define("shared/utils/emoji-picker", ["exports", "@picmo/popup-picker", "picmo"], function (_exports, _popupPicker, _picmo) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = emojiPicker;
  0; //eaimeta@70e063a35619d71f0,"@picmo/popup-picker",0,"picmo"eaimeta@70e063a35619d71f
  /**
   * Creates an emoji picker. See documentation for picker and popup options
   *
   * https://picmojs.com/docs/api/picmo/types/picker-options/
   * https://picmojs.com/docs/api/popup-picker/types/popup-options/
   */
  function emojiPicker(_ref) {
    let {
      rootElement,
      referenceElement,
      triggerElement,
      locale
    } = _ref;
    const emojiSize = '1.5rem';
    const emojisPerRow = 10;
    const emojiLocale = locale.primaryLocale === 'en-us' ? 'en' : locale.primaryLocale; // picmo does not recognize en-us as locale code
    const visibleRows = 8;
    const dataStore = _picmo.InMemoryStoreFactory;
    const position = 'right-start';
    return (0, _popupPicker.createPopup)({
      //PickerOptions
      className: 'picmo-custom-theme',
      emojiSize,
      emojisPerRow,
      locale: emojiLocale,
      rootElement,
      visibleRows,
      dataStore
    }, {
      // PopupOptions
      position,
      referenceElement,
      triggerElement
    });
  }
});